import { SUBSCRIBE_CHANNEL } from '../constants';
import createEntityLocalizer from '../utils/createEntityLocalizer';

interface LocalizedShortDateProps<D> {
    shortDate: D;
}

export const createLocalizedShortDate = <D,>({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizeShortDate',
} = {}) =>
    createEntityLocalizer<LocalizedShortDateProps<D>>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedShortDate',
        entityName: 'shortDate',
    });

export default createLocalizedShortDate();
